import { createContext } from 'react';
import { IDialogController } from '@/shared';

export const GlobalInformDialogContext = createContext<IDialogController>({
  show: () => ({
    close: () => {},
    afterClosed: () => Promise.resolve(),
  }),
});
